enum ThemeType {
  Auto = 'auto',
  Light = 'light',
  Sepia = 'sepia',
  Dark = 'dark',
}

export default ThemeType;
